import Login from './Login.vue'
export default Login


// WEBPACK FOOTER //
// ./src/pages/Login/index.js